import type { VerbTypes } from 'modules/core/lib/verbTypes'

import Policy from './Policy'

class PermissionGroupPolicy extends Policy<VerbTypes> {
  checkVerb(verb: VerbTypes): boolean {
    switch (verb) {
      case 'permissions.permissionsRead':
        return this.permissions.permissions.read

      default:
        throw new Error(`Unknown verb ${verb} in policy`)
    }
  }
}

export default PermissionGroupPolicy
